module.exports = __webpack_public_path__ + "img/Lobby_Video.6f986978.jpg";